import React from 'react'
import DropDown from '../dropdown';
import {Addons} from '../../../api/services/next'

export const ChainAddonsDropDown = ({...rest}) => {
 return <DropDown api={Addons.GetHotelChainAddons} textField="Name" valueField="Id" {...rest}/>
}